import React from 'react';
import { useNeuroMessages, NeuroMessage } from '@ignitesales/neuro-application';

const FeaturesTable = ({ products = [], htmlValues }) => {
    const { getMessage } = useNeuroMessages();

    const renderColumns = () => {
        return products.map((productId) => {
            const name = getMessage(`${productId}.features.column.name`);
            return (
                <td className="features-table--header-row" key={name} title={name}>
                    {name}
                </td>
            );
        })
    };

    const renderRows = () => {
        const count = getMessage(`${products[0]}.features.row.count`);
        const rows = []
        for (let index = 0; index < count; index++) {
            const msgIndex = index + 1;
            const row = products.map(productId => {
                return (<NeuroMessage id={`${productId}.features.row.content.${msgIndex}`} values={htmlValues} />);
            })
            rows.push({
                id: msgIndex,
                items: row
            })
        }
        return (
            rows.map((row) => {
                return (
                    <tr >
                        {row.items.map(item => <td className="features-table--features-row" key={row.id}>{item}</td>)}
                    </tr>)
            })
        )
    }
    const renderTable = () => {
        return (
            <table className="features-table--col">
                <thead >
                    <tr>
                        {renderColumns()}
                    </tr>
                </thead>
                <tbody>
                    {renderRows()}
                </tbody>
            </table>
        );
    };
    return (
        <div className="features-table">
            {renderTable()}
        </div>);
};

export default FeaturesTable;
